import React from 'react'

const MySvgIcon = ({ width = 32, height = 32 }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='none'
      version='1.1'
      width={width}
      height={height}
      viewBox='0 0 32 32'
    >
      <defs>
        <clipPath id='master_svg0_70_5721'>
          <rect x='0' y='0' width='32' height='32' rx='0' />
        </clipPath>
        <linearGradient
          x1='0.29664522409439087'
          y1='0.0716145858168602'
          x2='0.8705148002387014'
          y2='0.8305574417466007'
          id='master_svg1_1_0010'
        >
          <stop offset='0%' stopColor='#FFFFFF' stopOpacity='1' />
          <stop offset='67.68874526023865%' stopColor='#FFFFFF' stopOpacity='0' />
        </linearGradient>
      </defs>
      <g clipPath='url(#master_svg0_70_5721)'>
        <g>
          <rect x='0' y='0' width='32' height='32' rx='2.133333444595337' fill='#3B5A7A' fillOpacity='1' />
        </g>
        <g>
          <g>
            <path
              d='M23.46663349227905,15.73391C23.46663349227905,18.5322,21.181433492279055,20.8,18.36643349227905,20.8L9.866663492279052,20.8C7.336933492279053,20.669600000000003,5.333333492279053,18.8052,5.333333492279053,16.53391C5.333333492279053,14.80522,6.4954534922790526,13.31652,8.166003492279053,12.64696C8.514993492279054,12.50783,8.764773492279053,12.203479999999999,8.842723492279053,11.84174C9.313953492279053,9.65043,11.367153492279053,8,13.833113492279052,8C15.650733492279052,8,17.241533492279054,8.895652,18.145033492279055,10.24348C18.32213349227905,10.50957,18.607333492279054,10.68696,18.928033492279052,10.73391C21.50023349227905,11.11652,23.46663349227905,13.20522,23.46663349227905,15.73391Z'
              fill='url(#master_svg1_1_0010)'
              fillOpacity='1'
              style={{ mixBlendMode: 'passthrough' }}
            />
          </g>
          <g>
            <path
              d='M25.281933683013918,14.461896746139526Q24.047633683013917,13.064536746139527,22.189733683013916,12.777446746139526L22.188833683013918,12.777306746139526Q21.921433683013916,12.736626746139526,21.773833683013915,12.506316746139527Q20.328733683013915,10.266666746139526,17.633133683013916,10.266666746139526Q15.873563683013916,10.266666746139526,14.519693683013916,11.363386746139525Q13.181763683013916,12.447196746139527,12.838193683013916,14.107026746139526Q12.769823683013916,14.436656746139526,12.478983683013915,14.557116746139526Q11.250693683013916,15.068566746139528,10.504949683013916,16.111106746139527Q9.733333683013916,17.189826746139527,9.733333683013916,18.489416746139526Q9.733333683013916,20.216326746139526,11.017152683013917,21.467166746139526Q12.284113683013917,22.701566746139527,14.111933683013916,22.799466746139526L14.122623683013916,22.799966746139525L21.633133683013916,22.799966746139525Q23.665633683013915,22.799966746139525,25.101833683013915,21.318366746139525Q26.533333683013915,19.841596746139526,26.533333683013915,17.756086746139527Q26.533333683013915,15.878646746139527,25.281933683013918,14.461896746139526ZM22.067533683013917,13.568066746139527L22.068433683013915,13.568206746139527Q23.63983368301392,13.811326746139526,24.682333683013916,14.991516746139526Q25.733333683013917,16.181376746139527,25.733333683013917,17.756086746139527Q25.733333683013917,19.51749674613953,24.527433683013918,20.76156674613953Q23.326933683013916,21.999966746139528,21.633133683013916,21.999966746139528L14.144243683013915,21.999966746139528Q12.623463683013917,21.915266746139526,11.575423683013916,20.894166746139526Q10.533333683013916,19.878836746139527,10.533333683013916,18.489416746139526Q10.533333683013916,17.446496746139527,11.155623683013916,16.576536746139524Q11.768703683013916,15.719446746139527,12.786503683013915,15.295646746139527Q13.467153683013915,15.013736746139527,13.621523683013915,14.269496746139527Q13.907263683013916,12.889046746139526,15.023253683013916,11.985016746139527Q16.156933683013918,11.066666746139527,17.633133683013916,11.066666746139527Q19.892873683013917,11.066666746139527,21.101633683013915,12.940056746139526Q21.442933683013916,13.472686746139527,22.067533683013917,13.568066746139527Z'
              fillRule='evenodd'
              fill='#FFFFFF'
              fillOpacity='1'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default MySvgIcon
